// Preview-only route for design QA / polish gate.
// Mirrors the pattern of /promo-cards. Not linked from the user-facing app.
import { InviteSubmittedScreen } from '../components/InviteSubmittedScreen';

export default function InviteSubmittedPreview() {
  return (
    <InviteSubmittedScreen
      eventTitle="CatchUp with Alex"
      locationName="Blue Bottle Coffee"
      dateRangeLabel="May 22 – May 25"
      organizerName="Alex"
      submittedSlots={[
        { dayLabel: 'Tue, May 21', timeLabel: '7:30 – 9:00 PM', availableCount: 4, totalCount: 4 },
        { dayLabel: 'Wed, May 22', timeLabel: '6:30 – 9:00 PM', availableCount: 4, totalCount: 4 },
        { dayLabel: 'Sat, May 25', timeLabel: '11:00 AM – 12:30 PM', availableCount: 3, totalCount: 4 },
      ]}
    />
  );
}
